<template>
<kt-row>
    <kt-col xs="12">
        <form @submit.prevent="edit">
            <div id="status_msg"></div>
            <div id="user_pass_msg"></div>
            <kt-form-group>
                <kt-form-label>
                    {{ $t('label.change_status') }}
                </kt-form-label>
                <kt-form-select size="3" id="status" name="status" v-model="psp_request.status">
                    <option
                        v-bind:key="index"
                        v-for="(status, index) in statuses"
                        v-bind:value="status.value"
                        :selected="psp_request.status === status.value"
                    >
                        {{ status.name }}
                    </option>
                </kt-form-select>
            </kt-form-group>

            <kt-form-group v-if="psp_request.psp != 'saman' && psp_request.psp != 'parsian'">
                <kt-form-label for="username">
                    {{ $t('label.username') }}
                </kt-form-label>
                <kt-form-control
                        dir="ltr"
                        id="username"
                        name="username"
                        v-model="psp_request.username"
                >
                </kt-form-control>
            </kt-form-group>

            <kt-form-group v-if="psp_request.psp == 'saman'">
                <kt-form-label for="merchant_number_en">
                    {{ $t('label.merchant_number') }}
                </kt-form-label>
                <kt-form-control
                        dir="ltr"
                        id="merchant_number_en"
                        name="merchant_number"
                        v-model="psp_request.merchant_number"
                >
                </kt-form-control>
            </kt-form-group>

            <kt-form-group v-if="psp_request.psp == 'saman'">
                <kt-form-label for="terminal_number_en">
                    {{ $t('label.terminal_number') }}
                </kt-form-label>
                <kt-form-control
                        dir="ltr"
                        id="terminal_number_en"
                        name="terminal_number"
                        v-model="psp_request.terminal_number"
                >
                </kt-form-control>
            </kt-form-group>

            <kt-form-group v-if="psp_request.psp != 'parsian'">
                <kt-form-label for="password">
                    {{ $t('label.password') }}
                </kt-form-label>
                <kt-form-control
                        dir="ltr"
                        id="password"
                        name="password"
                        v-model="psp_request.password"
                >
                </kt-form-control>
            </kt-form-group>
            <kt-form-group v-if="psp_request.psp==='parsian'">
                <kt-form-label for="password">
                    {{ $t('label.pin') }}
                </kt-form-label>
                <kt-form-control
                        dir="pin"
                        id="pin"
                        name="pin"
                        v-model="psp_request.pin"
                >
                </kt-form-control>
            </kt-form-group>

            <kt-form-action class="mt-4">
                <button class="btn btn-md btn-success btn-wide" type="submit" id="edit_btn">
                    {{ $t('btn.edit') }}
                </button>
            </kt-form-action>
        </form>
    </kt-col>
</kt-row>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { pspRequestStatusStr, pspRequestStatus } from '@/constants/pspRequestStatus'
import { pspRequestService, ApiUrl } from '@/common/api.service'
import { i18n } from '@/plugins/i18n'
import axios from "axios";

export default {
    props: {
        psp_request: {
            required: true,
        }
    },
    data() {
        return {
            statuses: [
                {
                    name: pspRequestStatusStr.SUCCESS,
                    value: pspRequestStatus.SUCCESS
                },
                {
                    name: pspRequestStatusStr.PENDING,
                    value: pspRequestStatus.PENDING
                },
                {
                    name: pspRequestStatusStr.FAIL,
                    value: pspRequestStatus.FAIL
                },
                {
                    name: pspRequestStatusStr.END,
                    value: pspRequestStatus.END
                }
            ],
        }
    },
    methods: {
        edit(e) {
            let btn = $('#edit_btn')
            KTApp.progress(btn)

            pspRequestService.changeStatus(this.psp_request.id, this.psp_request.status).catch(({response}) => {
                this.showMsg($('#status_msg'), 'danger', response.data.message)
            })

            pspRequestService.changeUserPass(this.psp_request.id, {
                username: this.psp_request.username,
                password: this.psp_request.password,
                merchant_number: this.psp_request.merchant_number,
                terminal_number: this.psp_request.terminal_number,
                pin: this.psp_request.pin,
            }).then(response => {
                this.showMsg($('#user_pass_msg'), 'success', i18n.t('message.edit_success'))
            }).catch(({response}) => {
                this.showMsg($('#user_pass_msg'), 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>